import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  systemConfigService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'configurationModel',
    function (runtimeConstant, $http, $q, $filter, webApiSettings, Config) {
      'use strict';

      var config = null;

      function handleError(err, status) {
        if (status === 404 || status === -1) {
          var error = {
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
          return error;
        }

        if (status !== 400) {
          var ex = {
            title: $filter('translate')('UNEXPECTED ERROR'),
            text:
              err !== null && err !== ''
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
          };
          return ex;
        }
        return err;
      }

      function load() {
        var deferred = $q.defer();

        var url = 'configuration/';

        var promiseConfig = $http
          .get(webApiSettings.apiServiceBaseUri + url + 'company')
          .then((result) => resolveReferences(result.data))
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        var promiseHasDocs = $http.get(
          webApiSettings.apiServiceBaseUri + url + 'hasdocuments'
        );

        $q.all([promiseConfig, promiseHasDocs])
          .then((results) => {
            var confData = results[0];
            var hasDocs = results[1];

            config = new Config(confData, hasDocs.data);
            deferred.resolve(config);
          })
          .catch((err) => deferred.reject(err));

        return deferred.promise;
      }

      function save(configuration) {
        var deferred = $q.defer();

        var url = 'configuration';

        configuration.value0 = configuration.values.value0.type;
        configuration.value1 = configuration.values.value1.type;
        configuration.value2 = configuration.values.value2.type;
        configuration.value3 = configuration.values.value3.type;
        configuration.value4 = configuration.values.value4.type;
        configuration.value5 = configuration.values.value5.type;

        $http
          .put(webApiSettings.apiServiceBaseUri + url, configuration)
          .then(() => {
            config = configuration;
            deferred.resolve(configuration);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function saveLogo(company) {
        var logo = company.logo;

        var blob = new Blob([logo], { type: 'image/png' });
        var image = new File([blob], 'image.png');
        var url = 'companies/' + company.id + '/logo';

        var fd = new FormData();
        fd.append('file', image);
        $http.post(webApiSettings.apiServiceBaseUri + url, fd, {
          headers: { 'Content-Type': undefined },
        });
      }

      function getConfig() {
        return config;
      }

      function run() {
        try {
          var systemConfigCrudFactory = {};

          load();

          systemConfigCrudFactory.load = logWrapper(
            load,
            runtimeConstant.isDebugServicesInternals
          );
          systemConfigCrudFactory.save = logWrapper(
            save,
            runtimeConstant.isDebugServicesInternals
          );
          systemConfigCrudFactory.getConfig = logWrapper(
            getConfig,
            runtimeConstant.isDebugServicesInternals
          );
          systemConfigCrudFactory.saveLogo = logWrapper(
            saveLogo,
            runtimeConstant.isDebugServicesInternals
          );

          return systemConfigCrudFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
